export interface Article {
  id: string;
  title: string;
  coverImage: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  description: string;
  fullDescription: string;
  tags: string[];
  director: string;
  cast: string[];
  duration: string;
  region: string;
  language: string;
  releaseDate: string;
  updateInfo: string;
  episodeCount?: string;
  relatedMovieIds: string[];
}

export const articles: Record<string, Article> = {
  'movie-1': {
    id: 'movie-1',
    title: '流浪地球3',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%2C%20massive%20spaceship%20approaching%20a%20ringed%20planet%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20grand%20scale%20space%20adventure%2C%20cinematic%20quality%2C%20atmospheric%20nebula%20glow%2C%20clean%20composition&width=800&height=450&seq=article-01&orientation=landscape',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.2,
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，开启长达2500年的流浪之旅。第三部讲述人类抵达新星系后面临的全新挑战。',
    fullDescription: '在不远的将来，太阳急速衰老膨胀，地球面临被吞没的灭顶之灾。为拯救地球，人类在地球表面建造了上万座行星发动机，以逃离太阳系寻找新的家园，地球和人类就此踏上预计长达2500年的宇宙流浪之旅。\n\n《流浪地球3》作为系列第三部，故事承接前作，人类在经历了木星危机和太阳氦闪之后，终于抵达了半人马座比邻星系。然而新的恒星系统带来了前所未有的挑战——三颗恒星的复杂引力系统让地球难以稳定运行，而未知的外星文明痕迹也在这个星系中被发现。\n\n人类面临着前所未有的抉择：是继续在这片危险的星际空间寻找立足之地，还是重新启程前往更遥远的星系？在完成这一壮举的过程中，无数人挺身而出，演绎了可歌可泣的英雄故事。',
    tags: ['科幻', '灾难', '冒险', '国产大片'],
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '148分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2026-02-10',
    updateInfo: '2026-07-28 更新',
    relatedMovieIds: ['movie-6', 'movie-5', 'movie-8'],
  },
  'movie-2': {
    id: 'movie-2',
    title: '满江红2',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20cinematic%20scene%2C%20ancient%20Chinese%20military%20camp%20at%20night%2C%20torch-lit%20atmosphere%2C%20warm%20golden%20tones%2C%20period%20costume%20detail%2C%20dramatic%20composition%2C%20cinematic%20quality&width=800&height=450&seq=article-02&orientation=landscape',
    year: 2025,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.8,
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇命案牵出惊天阴谋。',
    fullDescription: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。小兵张大与亲兵营副统领孙均机缘巧合被裹挟进这巨大阴谋之中，宰相秦桧命两人限一个时辰之内找到凶手。\n\n伴随危机四伏的深入调查，宰相府总管何立、副总管武义淳、舞姬瑶琴等人卷入局中，案件的背后似乎隐藏着一场更大的阴谋。局中有局、人心叵测，一夜之间风云变幻，各方势力暗流涌动。\n\n《满江红2》延续前作的悬疑风格与快节奏叙事，在更宏大的历史背景下展开一场惊心动魄的权谋较量。',
    tags: ['历史', '悬疑', '剧情', '古装'],
    director: '张艺谋',
    cast: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    duration: '159分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-01-22',
    updateInfo: '2026-07-25 更新',
    relatedMovieIds: ['movie-7', 'movie-10', 'movie-4'],
  },
  'movie-3': {
    id: 'movie-3',
    title: '哪吒之魔童闹海',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20animated%20cinematic%20scene%2C%20young%20warrior%20with%20fire%20powers%20battling%20dragon%2C%20epic%20fantasy%20composition%2C%20vibrant%20red%20and%20blue%20contrast%2C%20dynamic%20action%2C%20cinematic%20quality%2C%20dramatic%20lighting&width=800&height=450&seq=article-03&orientation=landscape',
    year: 2025,
    category: '动画片',
    categorySlug: 'animation',
    rating: 9.0,
    description: '哪吒与敖丙在天劫之后灵魂幸存，太乙真人用莲藕重塑肉身。面对东海龙族的复仇，哪吒必须做出选择。',
    fullDescription: '天劫之后，哪吒和敖丙的灵魂虽然保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，但在重塑肉身的过程中却遇到重重困难。\n\n东海龙王得知哪吒敖丙还活着的消息后大为震怒，率领四海龙王水淹陈塘关，逼迫李靖交出哪吒。面对龙族的复仇和天庭的威压，哪吒必须在这千钧一发之际做出自己的选择。\n\n"我命由我不由天"——哪吒再次用自己的方式改写了命运，也重新定义了什么是英雄。',
    tags: ['动画', '神话', '奇幻', '国漫'],
    director: '饺子',
    cast: ['吕艳婷', '瀚墨', '陈浩', '绿绮'],
    duration: '144分钟',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-01-29',
    updateInfo: '2026-07-22 更新',
    relatedMovieIds: ['movie-9', 'movie-5', 'movie-12'],
  },
  'movie-4': {
    id: 'movie-4',
    title: '长安十二时辰',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20at%20night%2C%20lantern-lit%20streets%2C%20crowded%20marketplace%2C%20warm%20golden%20glow%2C%20cinematic%20wide-angle%20shot%2C%20grand%20palace%20architecture%2C%20atmospheric%20period%20drama&width=800&height=450&seq=article-04&orientation=landscape',
    year: 2025,
    category: '电视剧',
    categorySlug: 'tv-series',
    rating: 9.5,
    description: '唐朝天宝年间，长安城陷入一场惊天阴谋，死囚张小敬临危受命拯救都城。',
    fullDescription: '上元节前夕，长安城混入可疑人员，身陷囹圄的张小敬临危受命，与少年天才李必携手在十二时辰内破除隐患。全篇运用了创新的探案剧集结构与人物关系设定，把故事嵌套在当时的世界文化中心城市长安这样一个完美的切入点。\n\n在十二时辰内，张小敬必须在偌大的长安城中抓住潜入的突厥狼卫，阻止一场可能毁灭整个长安城的惊天阴谋。时间紧迫、线索纷繁，每一个时辰都关乎无数人的生死。\n\n本剧改编自马伯庸同名小说，以精良的制作和扣人心弦的剧情获得了观众的一致好评。',
    tags: ['古装', '悬疑', '历史', '小说改编'],
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    duration: '48集',
    region: '中国大陆',
    language: '汉语普通话',
    releaseDate: '2025-06-15',
    updateInfo: '2026-07-20 更新至48集',
    episodeCount: '48集全',
    relatedMovieIds: ['movie-2', 'movie-11', 'movie-7'],
  },
};

export const faqList = [
  {
    question: '桃花影院真的完全免费吗？',
    answer: '是的，桃花影院承诺永久免费。您无需注册会员、无需付费订阅，即可在线观看所有电影、电视剧和综艺节目。我们通过广告收入维持运营，确保每一位用户都能享受免费观影体验。',
  },
  {
    question: '桃花影院的视频画质如何？',
    answer: '桃花影院所有视频资源均提供高清画质（1080P），部分热门影片更支持4K超清画质。我们采用先进的视频压缩和CDN加速技术，确保您在观看过程中不会出现卡顿和缓冲现象。',
  },
  {
    question: '在桃花影院看电影需要下载播放器吗？',
    answer: '不需要。桃花影院采用先进的HTML5在线播放技术，直接在浏览器中即可流畅观看。无论您使用的是电脑、平板还是手机，只需打开网站即可开始观影，无需安装任何插件或播放器。',
  },
  {
    question: '桃花影院的资源更新速度快吗？',
    answer: '非常快。我们的内容团队每天24小时不间断更新，影院下线的新片通常在1-2周内上线，热播电视剧同步更新，让您在第一时间追到最新剧集。',
  },
  {
    question: '桃花影院支持哪些设备观看？',
    answer: '桃花影院全面支持PC端、平板和手机端观看。网站采用响应式设计，自动适配各种屏幕尺寸，无论您使用什么设备，都能获得最佳的观影体验。',
  },
  {
    question: '如何找到我想看的电影或电视剧？',
    answer: '您可以通过首页的分类导航浏览不同类型的影片，也可以使用搜索功能直接查找您想看的电影或电视剧。热门推荐和排行榜也能帮您发现更多精彩内容。',
  },
];